<body>
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <span id="headerText">Stay Connected</span>
            </div>
        </div>
        <hr><br>
        <div class="row">
            <div class="col-sm-6 animate__animated animate__fadeInLeft" style="display:flex">
                <img src="assets/social/fb.jpg" style="width:32px;height:32px;"> 
                <h3 style="margin-left:10px"> <strong>plantplaceph</strong></h3>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 animate__animated animate__fadeInLeft" style="display:flex;margin-top:10px">
                <img src="assets/social/gmail.png" style="width:32px;height:32px;"> 
                <h3 style="margin-left:10px"> <strong>plantplace@gmail.com</strong></h3>
            </div>
        </div>
    </div>
</body>